import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import useUser from '../../../../hooks/useUser';
import useVoiceCallAgentIntegration from '../../hooks/useVoiceCallAgentIntegration';
import { VoiceCallAgentType } from '../../interfaces';
import { VyseConfiguration as IVyseConfiguration } from '../../interfaces/Vyse';
import {
  getVoiceCallAgentConfigs,
  updateVoiceCallAgentConfigs,
} from '../../services';
import VyseConfiguration from '../VyseConfiguration/VyseConfiguration';
import styles from './VyseIntegrationDialog.module.scss';

interface VyseConfigurationDialogProps {
  onClose: () => void;
}

const VyseIntegrationDialog: FC<VyseConfigurationDialogProps> = ({
  onClose,
}) => {
  const [vyseConfigs, setVyseConfigs] = useState<IVyseConfiguration | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { selectedBusiness } = useUser();
  const { addIntegration } = useVoiceCallAgentIntegration();

  useEffect(() => {
    setLoading(true);
    setError(null);

    getVoiceCallAgentConfigs<IVyseConfiguration>(VoiceCallAgentType.VYSE)
      .then((configs) => setVyseConfigs(configs))
      .catch((error) => setError(error.message))
      .finally(() => setLoading(false));
  }, [selectedBusiness]);

  const handleUpdateConfigs = (config: IVyseConfiguration) => {
    return updateVoiceCallAgentConfigs<IVyseConfiguration>(
      VoiceCallAgentType.VYSE,
      config
    ).then(() => {
      onClose();
      toast.success('Updated Vyse configuration');
      addIntegration({ configType: VoiceCallAgentType.VYSE });
    });
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth='md'
      onClose={onClose}
      id={styles.vyseConfigurationDialog}
    >
      <DialogTitle>Configure Vyse</DialogTitle>
      {(loading || error) && (
        <DialogContent dividers>
          {error && !loading && <Alert severity='error'>{error}</Alert>}
          {loading && (
            <Box className={styles.loader}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
      )}
      {!loading && !error && (
        <VyseConfiguration
          configs={vyseConfigs || undefined}
          onClose={onClose}
          onUpdate={handleUpdateConfigs}
        />
      )}
    </Dialog>
  );
};
export default VyseIntegrationDialog;
